export enum HazmatPermit {
  Yes = 'Yes',
  No = 'No',
}
